/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resolve_ReportInputs */

const en_resolve_report = /** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolve`)
};

const id_resolve_report = /** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesaikan`)
};

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const es_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const fr_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const de_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const ja_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const zh_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const ar_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const it_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const ru_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const pt_resolve_report = en_resolve_report;

/** @type {(inputs: Resolve_ReportInputs) => LocalizedString} */
const ko_resolve_report = en_resolve_report;

/**
* | output |
* | --- |
* | "Resolve" |
*
* @param {Resolve_ReportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const resolve_report = /** @type {((inputs?: Resolve_ReportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resolve_ReportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resolve_report(inputs)
	if (locale === "es") return es_resolve_report(inputs)
	if (locale === "fr") return fr_resolve_report(inputs)
	if (locale === "de") return de_resolve_report(inputs)
	if (locale === "ja") return ja_resolve_report(inputs)
	if (locale === "zh") return zh_resolve_report(inputs)
	if (locale === "ar") return ar_resolve_report(inputs)
	if (locale === "id") return id_resolve_report(inputs)
	if (locale === "it") return it_resolve_report(inputs)
	if (locale === "ru") return ru_resolve_report(inputs)
	if (locale === "pt") return pt_resolve_report(inputs)
	return ko_resolve_report(inputs)
});